app.filter('object2Array', function() {
    return function(input) {
    	var out = []; 
    	var i = {};
     	for(i in input){
        	out.push(input[i]);
      	}
    	return out;
    };
});